import * as React from 'react';
import { ICartItem } from '../../../interfaces/checkout/cart/cartType';
import { IOptionItem } from '../../../interfaces/checkout/cart/IOptionItem';
import { sum } from '../../../helpers/cart/sum';

export const trhDiscount = (item: ICartItem): React.ReactNode => {
    const optionItems: IOptionItem = item.options ? JSON.parse(item.options) : {};
    if (optionItems.trhDiscount) {
        return (
            <span key={`${item.item_id}_trhDiscount`}>
                {optionItems.trhDiscount?.label} {sum(optionItems.trhDiscount?.value || '0')} €<br />
            </span>
        );
    }
    return null;
};
